import React, { useEffect, useState } from 'react'
import { WidgetsOutlined, ArrowBackIos, Description } from '@material-ui/icons'
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { history } from 'store'
import Loading from 'components/Loading'
import DeductionRequestService from 'services/deduction-request'
import { formatMoney } from 'helpers/Currency'
import Pagination from 'react-js-pagination'
import { Trans } from 'react-i18next'

export default function () {
  const defaultFilters = { per_page: 10, page: 1 };
  const [filters, setFilters] = useState(defaultFilters)
  const [isLoading, setIsLoading] = useState(false)
  const [deductions, setDeductions] = useState([])
  const [pagination, setPagination] = useState({})

  useEffect(() => {
    getDeductions()
  }, [filters])

  function getDeductions() {
    setIsLoading(true)
    const _filters = { ...filters }
    DeductionRequestService.all({ params: _filters })
      .then(res => {
        setDeductions(res.data.data)
        setPagination(res.data.pagination)
      })
      .finally(() => setIsLoading(false))
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page })

  return (
    <Container fluid>
      <Row className="mt-4">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row>
      <Row className="mt-3 align-items-end justify-content-between">
        <Col xs="auto" className="d-flex">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Deduções</h5>
        </Col>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12">
          <Row>
            <Col xs='12' md="4">
              <Link to="/elite/scancash/deductions/add">
                <Button className='mb-3'>
                  <Description /> Adicionar Dedução
                </Button>
              </Link>
            </Col>
          </Row>
          <Row className='text-center'>
            <Col xs='12' md="2">
              <Form.Group>
                <Form.Label className="text-left">Registros por página:</Form.Label>
                <Form.Control
                  as="select"
                  value={filters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page: 1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              {isLoading ? <Loading page /> : (
                <Table
                  bordered
                  striped
                  className='text-center'
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Ano Fiscal</th>
                      <th>Revenda</th>
                      <th>Valor</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deductions.map(deduction => (
                      <tr>
                        <td>{deduction.id}</td>
                        <td>{deduction.fiscal_year}</td>
                        <td>{deduction.alias ?? deduction.name}</td>
                        <td>{formatMoney(deduction.value)}</td>
                        <td>{deduction.observation}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6" className="d-flex justify-content-start">
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: pagination.from || '0' }} to{' '}
                {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col xs="12" md="6" className="d-flex justify-content-end">
              <Pagination
                activePage={pagination.current_page}
                itemsCountPerPage={pagination.per_page ? parseInt(pagination.per_page) : 0}
                totalItemsCount={pagination.total ? pagination.total : 0}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Card.Body>
      </Row>
    </Container>
  )
}